/**
 * Shared client-side configuration for empavision extensions.
 *
 * The one env contract every client `ext-*` package reads (REACT_APP_ prefix is
 * required for CRA/webpack to expose it to the browser):
 *   REACT_APP_EMPAVISION_URL             - e.g. https://empavision.com
 *   REACT_APP_EMPAVISION_INTEGRATION_ID  - this marketplace's integration id
 *   REACT_APP_DEV_API_SERVER_PORT        - (dev only) port of the local API server
 *
 * Read from the *host* app's environment at the host's build time, because each
 * marketplace compiles this package as source via its own webpack.
 */

const empavisionUrl = process.env.REACT_APP_EMPAVISION_URL || '';
const integrationId = process.env.REACT_APP_EMPAVISION_INTEGRATION_ID || '';

/**
 * Resolves the base URL of the host marketplace's *own* API server (which proxies
 * to empavision). Mirrors the Sharetribe Web Template's util/api.js so this
 * package stays self-contained (no import from host app code).
 *
 * @param {string} [marketplaceRootURL]
 * @returns {string}
 */
export const apiBaseUrl = marketplaceRootURL => {
  const port = process.env.REACT_APP_DEV_API_SERVER_PORT;
  const useDevApiServer = process.env.NODE_ENV === 'development' && !!port;

  if (useDevApiServer) {
    return `http://localhost:${port}`;
  }
  if (marketplaceRootURL) {
    return marketplaceRootURL.replace(/\/$/, '');
  }
  return typeof window !== 'undefined' ? window.location.origin : '';
};

export const config = {
  isEnabled: Boolean(empavisionUrl && integrationId),
  empavisionUrl,
  integrationId,
};
